// ANETT HORVATH — MediaImage Component
// Renders images from media library with cache-busting and luxury fallback.

import { FALLBACK_IMAGE } from '../../store/media-library';

interface MediaImageProps {
  src: string;
  alt?: string;
  className?: string;
}

export default function MediaImage({ src, alt = '', className = '' }: MediaImageProps) {
  return (
    <img
      src={src || FALLBACK_IMAGE}
      alt={alt}
      className={className}
      loading="lazy"
      onError={e => {
        const img = e.currentTarget;
        if (img.src !== FALLBACK_IMAGE) img.src = FALLBACK_IMAGE;
      }}
    />
  );
}
